<template>
<div id="detail_page">
    <div id="info_wrap">
        <div id="cafe_info">
            <div class="cafe-info-wrap">
                <div class="info-box-wrap">
                    <div class="cafe-thumbnail">
                        <swiper class="swiper" :options="swiperOption">
                            <swiper-slide :key="index" v-for="(item, index) in store_images" :style="storeImageStyle(item.photograph_path)"></swiper-slide>
                            <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                        </swiper>
                    </div>
                    <div class="cafe-description">
                        <div class="cafe-title">{{store_data.store_name}}</div>
                        <div class="cafe-loca">
                            <div class="loca-info">
                                <span class="cafe-length">{{store_data.distance}}Km</span>
                                <span class="cafe-subway">{{store_data.location_info}}</span><br>
                                <span class="cafe-location">{{store_data.address}} {{store_data.address_detail}}</span>
                            </div>
                            <div class="btn-map"><span class="cafe-map" @click="showMap">지도보기</span></div>
                        </div>
                        <div class="btn-detail-wrap">
                            <!-- 코드 추가 - 2020-12-21 -->
                            <div class="btn-total-fee" @click="showAllPopup">
                            전체 요금정보
                            <img src="" alt="">
                            </div> 
                            <!-- 코드 추가 - 2020-12-21 -->
                            <div class="btn-store-service" @click="goKioskMobile(store_data.store_id, store_data.store_name)" v-if="this.store_rescode == 0 && login_chk">
                                매장 이용
                                <img src="" alt="">
                            </div>          
                            <!-- 코드 추가 - 2020-12-21 -->         
                            <div class="btn-store-service" @click="popup_insert_newstore" v-if="this.store_rescode == 1">
                                신규매장 가입
                                <img src="" alt="">
                            </div>
                            <div class="btn-store-service" @click="popup_set_mystore" v-if="this.store_rescode == 2">
                                나의매장으로 등록
                                <img src="" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-wrap">
                    <div class="tab-header">
                        <ul>
                            <li data-tab="tab1" @click="choice_tab_click('SEAT')" :class="sel_tab == 'SEAT' ? 'active':''"><a href="javascript:void(0);">좌석</a></li>
                            <li data-tab="tab2" @click="choice_tab_click('GROOM')" :class="sel_tab == 'GROOM' ? 'active':''"><a href="javascript:void(0);">그룹룸</a></li>
                            <li data-tab="tab3" @click="choice_tab_click('LOCKER')" :class="sel_tab == 'LOCKER' ? 'active':''"><a href="javascript:void(0);">사물함</a></li>
                        </ul>
                    </div>
                    <div class="tab-body">
                        <ul>
                            <li id="tab1" :class="sel_tab == 'SEAT' ? 'active':''">
                                <div class="list-seat">
                                    <ul>
                                        <template v-if="seat_data.length > 0">
                                            <li :key="index" v-for="(item, index) in seat_data">

                                                <div :style="goodsTypeImageStyle(item.seat_type_code)"></div>
                                                <div>
                                                    <h4 class="seat-title">{{item.seat_type_name}}</h4>
                                                    <p class="seat-info">{{item.memo}}</p>
                                                    <span class="available-seat">현재 <strong>{{item.seat_available_count}}</strong>석 이용가능 / 총 {{item.seat_count}}석</span>
                                                    <!-- 코드 추가 - 2020-12-21 -->
                                                    <div class="btn-fee"><span @click="showPopup('SEAT', item.seat_type_code, item.seat_type_name)">요금정보 &nbsp;></span><img src="" alt=""></div>
                                                </div>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li>
                                                등록된 그룹룸이 없습니다.
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </li>
                            <li id="tab2" :class="sel_tab == 'GROOM' ? 'active':''">
                                <div class="list-seat list-groom">
                                    <ul>
                                        <template v-if="groom_data.length > 0">
                                            <li :key="index" v-for="(item, index) in groom_data">
                                                <div :style="goodsTypeImageStyle(item.groom_type_id)"></div>
                                                <div>
                                                    <h4 class="seat-title">{{item.type_name}}</h4>
                                                    <p class="seat-info">{{item.memo}}</p>
                                                    <span class="available-seat">현재 <strong>{{item.groom_available_count}}</strong>석 이용가능 / 총 {{item.groom_count}}석</span>
                                                    <!-- 코드 추가 - 2020-12-21 -->
                                                    <div class="btn-fee"><span @click="showPopup('GROOM', item.groom_type_id, item.type_name)">요금정보 &nbsp;></span><img src="" alt=""></div>
                                                </div>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li>
                                                등록된 그룹룸이 없습니다.
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </li>
                            <li id="tab3" :class="sel_tab == 'LOCKER' ? 'active':''">
                                <div class="list-seat list-locker">
                                    <ul>
                                        <template v-if="locker_data.length > 0">
                                            <li :key="index" v-for="(item, index) in locker_data">
                                                <div :style="goodsTypeImageStyle(item.type_code)"></div>
                                                <div>
                                                    <h4 class="seat-title">{{item.locker_tab_name}}</h4>
                                                    <p class="seat-info">{{item.memo}}</p>
                                                    <span class="available-seat">현재 <strong>{{item.locker_available_count}}</strong>석 이용가능 / 총 {{item.locker_count}}석</span>
                                                    <!-- 코드 추가 - 2020-12-21 -->
                                                    <div class="btn-fee"><span @click="showPopup('LOCKER', item.type_code, item.locker_tab_name)">요금정보 &nbsp;></span><img src="" alt=""></div>
                                                </div>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li>
                                                등록된 사물함이 없습니다.
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="info-detail-wrap">
                    <div class="info-detail">
                        <h4 class="detail-title">
                            <img src="../../assets/images/com_info.png" alt="com_info">
                            <span>카페 정보</span>
                        </h4>
                        <div class="detail-table-wrap">
                            <table class="detail-table">
                                <colgroup>
                                    <col width="3%;" />
                                    <col width="97%;" />
                                </colgroup>
                                <thead></thead>
                                <tbody>
                                    <tr class="phone">
                                        <td><img src="../../assets/images/com_info01.png" class="detail-icon" alt="phone"></td>
                                        <td><span>연락처</span></td>
                                    </tr>
                                    <tr class="phone">
                                        <td></td>
                                        <td><a :href="'tel:'+store_data.store_tel_number"><span>{{store_data.store_tel_number}}</span></a><br>

                                        <span v-if="store_kakao_id.length > 0">카카오톡 ID : {{store_kakao_id}}</span><span v-if="store_kakao_id.length > 0"><span class="btn-cs" @click="go_link(store_data.store_kakao_link)">문의하기 > </span> </span></td>
                                    </tr>
                                    <tr class="cafe-time">
                                        <td><img src="../../assets/images/com_info02.png" class="detail-icon" alt="time"></td>
                                        <td>
                                            <span>운영시간</span>
                                        </td>
                                    </tr>
                                    <tr class="cafe-time">
                                        <td></td>
                                        <td><span>{{store_data.start_time}} ~ {{store_data.end_time}} 연중무휴</span></td>
                                    </tr>
                                    <tr class="cafe-rule">
                                        <td><img src="../../assets/images/com_info03.png" class="detail-icon" alt="rule"></td>
                                        <td>
                                            <span>매장규정</span>
                                        </td>
                                    </tr>
                                    <tr class="cafe-rule">
                                        <td></td>
                                        <td>
                                            <ul>
                                                <!-- <li>매장 내 외부 음식물 섭취 금지</li>
                                                    <li>코로나로 인한 마스크 착용 필수</li>
                                                    <li>3회 경고 받을 시 강제 퇴실 조치</li> -->
                                                <li>{{store_data.store_regulation}}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr class="cafe-refund">
                                        <td><img src="../../assets/images/com_info04.png" class="detail-icon" alt="refund"></td>
                                        <td>
                                            <span>환불규정</span>
                                        </td>
                                    </tr>
                                    <tr class="cafe-refund">
                                        <td></td>
                                        <!-- <td><span>입실 3시간 전 전액 환불</span></td> -->
                                        <td><span>{{store_data.refund_regulation}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="policy-content">
        <div class="btn-close" @click="close_layer">
            <span class="bar"></span>
            <span class="bar"></span>
        </div>
        <iframe :src="kakao_link" frameborder="0"></iframe>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';
import {
    Swiper,
    SwiperSlide
} from 'vue-awesome-swiper'
import SwiperCore, {
    Pagination,
    Autoplay
} from 'swiper'
import 'swiper/swiper-bundle.css'

SwiperCore.use([Pagination, Autoplay]);

export default {
    name: 'detail_page',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            // store_rescode 코드 0 = 이미 홍보앱의 나의매장에 등록되어있음
            // store_rescode 코드 1 = 홍보앱의 나의매장에 등록되어있지 않고 , 해당키오스크 에 내 연락처가 없음 (신규가입 필요)
            // store_rescode 코드 2 = 홍보앱의 나의매장에 등록되어있지 않지만 , 해당키오스크 에 내 연락처가 존재 (홍보앱의 나의매장에 등록필요)
            store_rescode: 0,
            sel_tab: 'SEAT',            
            store_data: {},
            seat_data: [],
            groom_data: [],
            locker_data: [],
            store_images: [],
            goods_images: [],
            all_price_data: [],
            seat_price_data: [],
            groom_price_data: [],
            locker_price_data: [],
            login_chk:false,
            store_kakao_id:'',
            store_kakao_link:'',
            user_id:'',
            host: config.HOST,
            swiperOption: {
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 2500,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            },
            kakao_link: '',
            user_join_yn:'N',
            store_info:{},
        }
    },
    created() {
        EventBus.$on('popup_close', (data) => {
            common.setLocationData((data) => {
                var params = common.getParams();               
                data.store_id = params.store_id;
                this.getDataList(data);
            })
        });
    },
    mounted() {
        this.$nextTick(function () {
            common.setLocationData((data) => {
                var params = common.getParams();
                // console.log(params);
                // console.log('detail');
                data.store_id = params.store_id;
                this.getDataList(data);                
                this.getStoreOption(data);
            });
            
        });
    },
    methods: {
        go_link(link){
            // 안드로이드일 경우
            console.log('common.getMobileDevice :: ', common.getMobileDevice)
            if(!common.getMobileDevice()){
                common.goKakaoChannel(link);
            // IOS일 경우
            }else{
                window.webkit.messageHandlers.openKakao.postMessage(link);
                
                //this.kakao_link = link;
                //document.getElementById('policy-content').classList.add('on');
                //document.getElementById('info_wrap').style.display = 'none';
            }
        },
        close_layer() {
            document.getElementById('policy-content').classList.remove('on');
            document.getElementById('info_wrap').style.display = 'block';
        },
        choice_tab_click(type) {
            this.sel_tab = type;
        },
        getDataList(data) {
            let type = [config.REQ_STORE_INFO, config.REQ_STORE_GOODS_TYPE_INFO_LIST, config.REQ_STORE_GOODS_TYPE_IMAGE_LIST];
            common.getDataList(
                type,
                data,
                (responseList) => {                    
                    this.store_data = responseList[0][0];                    
                    this.store_kakao_id = this.store_data.store_kakao_id;
                    this.store_kakao_link = this.store_data.store_kakao_link;                      
                    this.seat_data = responseList[1].seat;
                    this.groom_data = responseList[1].groom;
                    this.locker_data = responseList[1].locker;
                    this.store_images = responseList[2].store;
                    if(this.store_images[0] === undefined) {
                        this.store_images[0] = []
                        this.store_images[0].photograph_path = 'images/MOBILE/defalut.jpg'
                    }
                    this.goods_images = responseList[2].goods;                    
                    var login_chk = this.$store.getters['getLogin_chk'];
                    if (login_chk) {
                        this.login_chk = true;
                        var user_info = this.$store.getters['getUser_info'];
                        var data = {
                            user_hp: user_info.value.user_hp,
                            store_id: this.store_data.store_id,
                            m_user_id: user_info.value.m_user_id
                        }
                        var type = config.REQ_CHECK_USER_JOIN_TO_STORE;
                        common.getData(type, data,
                            (response) => {
                                this.store_rescode = response.rescode;
                                if(response.rescode == 0){
                                    this.user_id = response.user_id; 
                                }
                            })
                        this.$store.commit('setDetail_sel_store_id', {
                            value: this.store_data.store_id
                        });
                    }

                })
        },
        storeImageStyle(image_path) {
            if(image_path == "images/MOBILE/defalut.jpg"){
                return "background: url(" + this.host + "/" + image_path + ") no-repeat center center/cover;background-size: 60%;";
            }else{
                return "background: url(" + this.host + "/" + image_path + ") no-repeat center center/cover;";
            }
        },
        goodsTypeImageStyle(type_code) {
            var defalut_img = '/images/MOBILE/defalut.jpg';           
            var image = "background: url(" + this.host + "/" + defalut_img + ") no-repeat center center/cover;background-size: 60%;";            
            for (var i = 0; i < this.goods_images.length; i++) {                
                if (type_code == this.goods_images[i].item_type_code) {                    
                    image = "background: url(" + this.host + "/" + this.goods_images[i].photograph_path + ") no-repeat center center/cover";
                }
            }
            return image;
        },
        showAllPopup(){
            var params = common.getParams();
            params.code = '';
            let type = [config.REQ_STORE_SEAT_PRICE_LIST, config.REQ_STORE_GROOM_PRICE_LIST, config.REQ_STORE_LOCKER_PRICE_LIST];
            common.getDataList(
                type,
                params,
                (responseList) => {
                    var reqData = {};
                    reqData.seat = responseList[0];
                    reqData.groom = responseList[1];
                    reqData.locker = responseList[2];                    

                    var data = {
                        code: this.$store.state.popup_code.TAB_TABLE,
                        res: reqData,
                        name: '',
                        store_info: this.store_info
                    };
                    EventBus.$emit('popup-data', data);

                })
            document.body.classList.add('modal-open');
        },
        showPopup(type, code, name) {
            var params = common.getParams();
            params.code = code;
            var req;
            if (type == 'SEAT') {
                req = config.REQ_STORE_SEAT_PRICE_LIST;
            } else if (type == 'GROOM') {
                req = config.REQ_STORE_GROOM_PRICE_LIST;
            } else if (type == 'LOCKER') {
                req = config.REQ_STORE_LOCKER_PRICE_LIST;
            }
            common.getData(req, params, (response) => {
                var data = {
                    code: this.$store.state.popup_code.TABLE,
                    res: response,
                    name: name,
                    type: type,
                    store_info: this.store_info
                };
                console.log(data);
                EventBus.$emit('popup-data', data);
            })
            document.body.classList.add('modal-open');
        },
        showMap() {
            // this.$router.push('/map');
            var data = {
                code: this.$store.state.popup_code.MAP
            };
            EventBus.$emit('popup-data', data);
        },
        popup_set_mystore() {
            var data = {
                code: 99
            };
            EventBus.$emit('popup-data', data);
            document.body.classList.add('modal-open');
        },
        popup_insert_newstore() {
            if(this.user_join_yn == "Y"){
                var data = {
                    code: 103,
                    message: '매장 관리자에게 문의해주세요.'
                };
                EventBus.$emit('popup-data', data);
                return false;
            }

            var data = {
                code: 100
            };
            EventBus.$emit('popup-data', data);
        },
        
        goKioskMobile(store_id, store_name){           
            var data = {};
            data.store_id = store_id;
            data.user_id = this.user_id;
            data.store_name = store_name;            
            var params = JSON.stringify(data);
            common.goKioskMobile(params);
        },

        getStoreOption(store_data){
            var type = config.REQ_STORE_OPTION;
            let data = {}
            data.store_id = store_data.store_id;
            common.getData(type, data,
            (response) => {                
                this.user_join_yn = response.data.user_join_yn;
                this.store_info = {
                    card_only : response.data.card_only
                } 
            })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/DetailPage.vue